import '#styles/themes'
import { css } from '@linaria/core'
import { type FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { RouterProvider } from 'react-router-dom'
import { FullscreenLoading } from '#components/FullScreenLoading'
import { DebugPortalContextProvider } from '#features/DebugSettings/DebugPortal'
import { initializeUserManager } from '#features/User/userManager'
import type { ReactRouter } from '#types/react-router'

const DelayedRouter = () => {
  const [router, setRouter] = useState<ReactRouter | undefined>()
  const [error, setError] = useState<unknown>()
  const { t } = useTranslation()

  useEffect(() => {
    let cancelled = false
    const load = async () => {
      try {
        await initializeUserManager()

        const { router } = await import('./app/routes/router')
        if (cancelled) {
          return
        }
        setRouter(router)
      } catch (e) {
        if (cancelled) {
          return
        }
        console.error(e)
        setError(e)
      }
    }
    load().catch(console.error)
    return () => {
      cancelled = true
    }
  }, [])

  if (error) {
    return <div>{t('app.startup-error', 'Failed loading MAN Intelligent Configurator!')}</div>
  }

  if (!router) {
    return <FullscreenLoading />
  }

  return <RouterProvider router={router} />
}

const appClass = css`
  @media screen {
    margin: auto;
    width: 100%;
  }
`

export const App: FC = () => {
  return (
    <DebugPortalContextProvider>
      <div className={appClass}>
        <DelayedRouter />
      </div>
    </DebugPortalContextProvider>
  )
}
